// Contact Us Form Success Message Modal
let contactUsSuccessModal = document.getElementById("contact_us_success_modal");
let contactUsSuccessClose = document.getElementsByClassName(
  "contact-us-success-close"
)[0];
if (contactUsSuccessClose !== undefined) {
  contactUsSuccessClose.onclick = function () {
    contactUsSuccessModal.style.display = "none";
    $(".hero__animation-contents").css({ opacity: 1 });
    $(".hero__text-wrap").css({ "z-index": 1 });
  };
}

$(".contact-us-success-close").click(function () {
  contactUsSuccessModal.style.display = "none";
  $(".hero__animation-contents").css({ opacity: 1 });
  $(".hero__text-wrap").css({ "z-index": 1 });
});

// Contact Us Form Success Message Modal - Set CSS Properties
if ($("#contact_us_success_modal").length) {
  $(".hero__animation-contents").css({ opacity: 0 });
  $(".hero__text-wrap").css({ "z-index": -1 });
} else {
  $(".hero__animation-contents").css({ opacity: 1 });
  $(".hero__text-wrap").css({ "z-index": 1 });
}

// Contact Us Form Validations
$(".contact-us-submit").click(function (event) {
  event.preventDefault();
  $(".contact-us-name-validation").remove();
  $(".contact-us-email-validation").remove();
  $(".contact-us-topic-validation").remove();
  $(".contact-us-new-shipping-address-validation").remove();
  $(".contact-us-order-number-validation").remove();
  $(".contact-us-message-validation").remove();

  let name = $(".contact-us-name").val();
  if (name === "") {
    $(".contact-us-name").after(
      '<span tabindex="0" id="name-error" class="contact-us-validation-message contact-us-name-validation error-message"> Name is a mandatory field </span>'
    );
  }

  let email = $(".contact-us-email").val();
  if (email === "") {
    $(".contact-us-email").after(
      '<span  tabindex="0"  id="email-error" class="contact-us-validation-message contact-us-email-validation error-message"> Email is a mandatory field </span>'
    );
  }

  let topic = $(".contact-us-topic option:selected").val();
  if (topic === "") {
    $(".contact-us-topic").after(
      '<span  tabindex="0"  id="topic-error" class="contact-us-validation-message contact-us-topic-validation error-message"> Select topic is a mandatory field </span>'
    );
  }

  if (topic !== "") {
    let topicValue = $(".contact-us-topic option:selected").val();
    if (topicValue === "I need to change the shipping address in my order") {
      let shippingAddress = $(".contact-us-new-shipping-address").val();
      if (shippingAddress === "") {
        $(".contact-us-new-shipping-address").after(
          '<span id="shipping-error" class="contact-us-validation-message contact-us-new-shipping-address-validation error-message"> Shipping Address is a mandatory field </span>'
        );
      }
    }
  }

  let orderNumber = $(".contact-us-order-number").val();
  if (orderNumber === "") {
    $(".contact-us-order-number").after(
      '<span  tabindex="0"  id="order-error" class="contact-us-validation-message contact-us-order-number-validation error-message"> Order Number is a mandatory field </span>'
    );
  }

  let message = $(".contact-us-message").val();
  if (message === "") {
    $(".contact-us-message").after(
      '<span  tabindex="0"  id="message-error" class="contact-us-validation-message contact-us-message-validation"> Message is a mandatory field </span>'
    );
  }
  if (
    name === "" ||
    email === "" ||
    topic === "" ||
    orderNumber === "" ||
    message === ""
  ) {
    setTimeout(() => {
      $($(".error-message")[0]).focus();
    }, 0);
  }
  if (
    name === "" ||
    email === "" ||
    topic === "" ||
    orderNumber === "" ||
    message === ""
  ) {
    return false;
  } else {
    if (topic !== "") {
      let topicValue = $(".contact-us-topic option:selected").val();
      if (topicValue === "I need to change the shipping address in my order") {
        let shippingAddress = $(".contact-us-new-shipping-address").val();
        if (shippingAddress === "") {
          return false;
        }
      }

      let formId = $(".contact_us_form_id").val();
      $("#" + formId).submit();
      setTimeout(() => {
        $("#success-message").focus();
      }, 0);
    }
  }

  $(".contact-us-success-close").on("click", function () {
    contactUsSuccessModal.style.display = "none";
    $(".hero__animation-contents").css({ opacity: 1 });
    $(".hero__text-wrap").css({ "z-index": 1 });
  });
});

$(".contact-us-submit").keydown(function (event) {
  let name = $(".contact-us-name").val();
  let email = $(".contact-us-email").val();
  let orderNumber = $(".contact-us-order-number").val();
  let topic = $(".contact-us-topic option:selected").val();
  let message = $(".contact-us-message").val();
  if (event.keyCode == 32 || event.keyCode == 13) {
    if (
      name === "" ||
      email === "" ||
      topic === "" ||
      orderNumber === "" ||
      message === ""
    ) {
      setTimeout(() => {
        $($(".error-message")[0]).focus();
      }, 0);
    }
  }
});
// Contact Us Form Clear Validation Messages
$(".contact-us-name").keypress(function () {
  $(".contact-us-name-validation").remove();
});

$(".contact-us-email").keypress(function () {
  $(".contact-us-email-validation").remove();
});

$(".contact-us-topic").change(function () {
  $(".contact-us-topic-validation").remove();
});

$(".contact-us-new-shipping-address").keypress(function () {
  $(".contact-us-new-shipping-address-validation").remove();
});

$(".contact-us-order-number").keypress(function () {
  $(".contact-us-order-number-validation").remove();
});

$(".contact-us-message").keypress(function () {
  $(".contact-us-message-validation").remove();
});

$("select.ContactFormTopic").change(function () {
  var selectedTopic = $(this).children("option:selected").val();
  if (selectedTopic === "I need to change the shipping address in my order") {
    $("#NewShippingAddress").attr("required", true);
    $("#hidden-new-address").show();
  } else {
    $("#NewShippingAddress").attr("required", false);
    $("#hidden-new-address").hide();
  }
});
